import { Component, Input } from '@angular/core';
import { CampaignDrawerService } from '@finder/shared/services/campaign-drawer/campaign-drawer.service';
import { CampaignDrawerGroupBase } from '@finder/shared/components/campaign-drawer-base/campaign-drawer-group-base';
import { ComponentHeaderComponent } from '../component-header/component-header.component';
import { CommonModule } from '@angular/common';
import { CampaignDrawerLinkComponent } from '../campaign-drawer-link/campaign-drawer-link.component';

@Component({
    selector: 'finder-campaign-drawer-link-group',
    templateUrl: './campaign-drawer-link-group.component.html',
    styleUrls: ['./campaign-drawer-link-group.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ComponentHeaderComponent,
        CampaignDrawerLinkComponent
    ]
})
export class CampaignDrawerLinkGroupComponent extends CampaignDrawerGroupBase {
    @Input() groupData;

    constructor(
        protected drawerService: CampaignDrawerService,
    ) {
        super(drawerService);
    }
}
